package com.vamvisions.main.navigation

import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.attributes.ATarget
import org.jetbrains.compose.web.attributes.AttrsScope
import org.jetbrains.compose.web.attributes.target
import org.jetbrains.compose.web.dom.A
import org.w3c.dom.HTMLAnchorElement

/** A link to another site. It opens in a new tab without giving that page access to this one. */
@Composable
fun ExternalLink(
    href: String,
    attrs: (AttrsScope<HTMLAnchorElement>.() -> Unit)? = null,
    content: @Composable () -> Unit,
) {
    A(
        href = href,
        attrs = {
            target(ATarget.Blank)
            attr("rel", "noopener noreferrer")
            attrs?.invoke(this)
        },
    ) {
        content()
    }
}
